export const STATUS_REPORT_REQUEST = 'STATUS_REPORT_REQUEST';
export const STATUS_REPORT_SUCCESS = 'STATUS_REPORT_SUCCESS';
export const STATUS_REPORT_FAIL = 'STATUS_REPORT_FAIL';